document.addEventListener("DOMContentLoaded", function () {
  // Price per Unit
  const pricePerUnit = function () {
    const productData = JSON.parse(
      document.getElementById("ProductJson").innerText
    );
    const variantDataElement = document.getElementById("wf-variant-data");
    const variantData = JSON.parse(
      variantDataElement.getAttribute("data-variants")
    );

    const variantSelector = document.querySelector(
      ".product-variant__container"
    );
    if (variantSelector) {
      variantSelector.addEventListener("change", function (e) {
        const optionName1 = e.target.value;
        fetchVariantData(optionName1);
      });
    }
    function fetchVariantData(optionName1) {
      const variant = productData.variants.find(
        (v) => v.option1 === optionName1
      );
      if (!variant) return;
      const units = Number(
        variantData.find((v) => Number(v.id) === variant.id).portionsgroesse
      );
      if (document.querySelector(".wf-price-per-unit--wrapper")) {
        let node1 = document.querySelector(".wf-price-per-unit");
        node1.innerHTML = node1.getAttribute("data-template").replace(
          "[price]",
          parseFloat(variant.price / 100 / units)
            .toFixed(2)
            .replace(".", ",")
        );
      }
    }
  };
  pricePerUnit();

  // Size Chart
  const sizeChart = function () {
    const openPopupBtn = document.getElementById("wfOpenPopupSize");
    const popup = document.getElementById("wfPopupSize");
    const closePopupBtn = document.getElementById("wfClosePopupSize");

    if (openPopupBtn && popup && closePopupBtn) {
      // Open popup on button click
      openPopupBtn.addEventListener("click", function () {
        popup.style.display = "block";
        document.body.classList.add("wf-no-scroll");
      });

      // Close popup on close button click
      closePopupBtn.addEventListener("click", function () {
        popup.style.display = "none";
        document.body.classList.remove("wf-no-scroll");
      });

      // Close popup when clicking outside the popup content
      window.addEventListener("click", function (event) {
        if (event.target === popup) {
          popup.style.display = "none";
          document.body.classList.remove("wf-no-scroll");
        }
      });
    }
  };
  sizeChart();

  // Kaffeeröstung Chart
  const roastingChart = function () {
    const openPopupBtn = document.getElementById("wfOpenPopupRoasting");
    const popup = document.getElementById("wfPopupRoasting");
    const closePopupBtn = document.getElementById("wfClosePopupRoasting");

    if (openPopupBtn && popup && closePopupBtn) {
      // Open popup on button click
      openPopupBtn.addEventListener("click", function () {
        popup.style.display = "block";
        document.body.classList.add("wf-no-scroll");
      });

      // Close popup on close button click
      closePopupBtn.addEventListener("click", function () {
        popup.style.display = "none";
        document.body.classList.remove("wf-no-scroll");
      });

      // Close popup when clicking outside the popup content
      window.addEventListener("click", function (event) {
        if (event.target === popup) {
          popup.style.display = "none";
          document.body.classList.remove("wf-no-scroll");
        }
      });
    }
  };
  roastingChart();
});
